/**
 * Global analytics facade for gtag / dataLayer.
 *
 * Usage:
 *   FmAnalytics.track('event_name', { key: 'value' });
 *
 * Declarative clicks — put all params on the trigger node:
 *   <a data-fm-track="banner_item_click"
 *      data-fm-banner-index="0"
 *      data-fm-banner-link="/collections/all"
 *      data-fm-section-index="1">...</a>
 *
 * Checkout discount codes (same click track; one event per code):
 *   <button data-fm-track="discount_code_checkout"
 *           data-fm-discount-codes="SAVE10,WELCOME">...</button>
 *
 * Mapping: data-fm-{param} → GA4 event param {param}
 *   data-fm-banner-index → banner_index
 *   data-fm-section-index → section_index
 * page_type is injected automatically from FoxTheme.settings.pageType
 * (set in snippets/js-variables.liquid via request.page_type).
 */
(function () {
  'use strict';

  if (window.FmAnalytics) return;

  var TRACK_ATTR = 'data-fm-track';
  var DISCOUNT_CODES_ATTR = 'data-fm-discount-codes';
  var PARAM_PREFIX = 'fm';
  var RESERVED_KEYS = { track: true, discount_codes: true };

  function getPageType() {
    try {
      if (window.FoxTheme && FoxTheme.settings && FoxTheme.settings.pageType) {
        return FoxTheme.settings.pageType;
      }

      if (
        window.Shopify &&
        Shopify.analytics &&
        Shopify.analytics.meta &&
        Shopify.analytics.meta.page &&
        Shopify.analytics.meta.page.pageType
      ) {
        return Shopify.analytics.meta.page.pageType;
      }

      var body = document.body;
      if (body && body.className) {
        var match = body.className.match(/(?:^|\s)([\w-]+)-template(?:\s|$)/);
        if (match) return match[1];
      }

      return '';
    } catch (e) {
      return '';
    }
  }

  function coerceValue(value) {
    if (value === '' || value == null) return value;
    if (value === 'true') return true;
    if (value === 'false') return false;
    if (/^-?\d+$/.test(value)) return Number(value);
    if (/^-?\d+\.\d+$/.test(value)) return Number(value);
    return value;
  }

  /**
   * Collect every data-fm-* on the trigger element (except data-fm-track).
   * data-fm-banner-index → banner_index
   */
  function collectDatasetParams(element) {
    var params = {};
    if (!element || !element.dataset) return params;

    Object.keys(element.dataset).forEach(function (key) {
      if (key.indexOf(PARAM_PREFIX) !== 0) return;
      var paramKey = key.slice(PARAM_PREFIX.length);
      if (!paramKey) return;

      paramKey = paramKey.charAt(0).toLowerCase() + paramKey.slice(1);
      paramKey = paramKey.replace(/[A-Z]/g, function (match) {
        return '_' + match.toLowerCase();
      });

      if (RESERVED_KEYS[paramKey]) return;
      params[paramKey] = coerceValue(element.dataset[key]);
    });

    return params;
  }

  function send(eventName, params) {
    if (typeof window.gtag === 'function') {
      window.gtag('event', eventName, params);
      return;
    }

    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(Object.assign({ event: eventName }, params));
  }

  function track(eventName, payload) {
    if (!eventName) return;

    var params = Object.assign(
      { page_type: getPageType() },
      payload || {}
    );

    console.log('[FmAnalytics]', eventName, params);
    send(eventName, params);
  }

  function findTrackElement(event) {
    var path = typeof event.composedPath === 'function' ? event.composedPath() : [];
    for (var i = 0; i < path.length; i++) {
      var node = path[i];
      if (node && node.nodeType === 1 && node.getAttribute && node.getAttribute(TRACK_ATTR)) {
        return node;
      }
    }

    var target = event.target;
    if (target && target.nodeType === 3) target = target.parentElement;
    if (!target || typeof target.closest !== 'function') return null;
    return target.closest('[' + TRACK_ATTR + ']');
  }

  function parseDiscountCodes(raw) {
    if (!raw) return [];
    return String(raw)
      .split(',')
      .map(function (code) {
        return code.trim();
      })
      .filter(Boolean);
  }

  /** Keep checkout buttons in sync after apply/remove discount (cart.js codes). */
  function setCheckoutDiscountCodes(codes) {
    var list = Array.isArray(codes) ? codes : parseDiscountCodes(codes);
    var value = list.join(',');
    document.querySelectorAll('[' + TRACK_ATTR + '="discount_code_checkout"]').forEach(function (el) {
      el.setAttribute(DISCOUNT_CODES_ATTR, value);
    });
  }

  function onDelegatedClick(event) {
    var trackEl = findTrackElement(event);
    if (!trackEl) return;

    var eventName = trackEl.getAttribute(TRACK_ATTR);
    if (!eventName) return;

    var baseParams = collectDatasetParams(trackEl);
    var codesRaw = trackEl.getAttribute(DISCOUNT_CODES_ATTR);

    // Same track API: one event per discount code when data-fm-discount-codes is set.
    if (codesRaw != null && eventName === 'discount_code_checkout') {
      parseDiscountCodes(codesRaw).forEach(function (code) {
        track(eventName, Object.assign({}, baseParams, { discount_code: code }));
      });
      return;
    }

    track(eventName, baseParams);
  }

  document.addEventListener('click', onDelegatedClick, true);

  window.FmAnalytics = {
    track: track,
    setCheckoutDiscountCodes: setCheckoutDiscountCodes,
  };
})();
